// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1hxZn","content":"styles_content__1z8Xm"};